<mat-card class="mat-card mat-card--widget">
  <div class="row order-list-table is-fullwidth">
    <table mat-table [dataSource]="bulkOrderList" class="mt-50 is-fullwidth" matSort>
      <!-- FileName Column -->
      <ng-container matColumnDef="filename">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>File Name</th>
        <td mat-cell *matCellDef="let element">{{ element.filename }}</td>
      </ng-container>

      <!-- UploadOn Column -->
      <ng-container matColumnDef="itemCount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Line #</th>
        <td mat-cell *matCellDef="let element">{{ element.itemCount }}</td>
      </ng-container>
      <!-- UploadedOn Column -->
      <ng-container matColumnDef="uploadedOn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Uploaded On</th>
        <td mat-cell *matCellDef="let element">{{ formatLocalTime(element.uploadedOn + 'Z') | date: 'short' }}</td>
      </ng-container>
      <!-- UploadStatus -->
      <ng-container matColumnDef="uploadStatus">
        <th mat-header-cell *matHeaderCellDef>Upload Status</th>
        <td mat-cell *matCellDef="let element">{{ element.uploadStatus }}</td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button class="btn btn-primary" [routerLink]="'details/' + element.bulkOrderId">View Details</button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="bulkOrderColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: bulkOrderColumns"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons> </mat-paginator>
  </div>
</mat-card>
